import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import PermissionsTable from './components/PermissionsTable'
import PermissionsProvider from './PermissionsContext'

function Permissions() {
  return (
    <UserSelectProvider>
      <PermissionsProvider>
        <PermissionsTable />
      </PermissionsProvider>
    </UserSelectProvider>
  )
}

export default Permissions
